import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-general-terms-screen',
  templateUrl: './general-terms-screen.component.html',
  styleUrls: ['./general-terms-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneralTermsScreenComponent {}
